"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var marked = require("marked");
var ɵngcc0 = require('@angular/core');
var MarkdownToHtmlPipe = (function () {
    function MarkdownToHtmlPipe() {
    }
    MarkdownToHtmlPipe.prototype.transform = function (markdown, options) {
        if (markdown == null)
            return '';
        return marked(markdown, options);
    };
    MarkdownToHtmlPipe.setOptions = function (options) {
        marked.setOptions(options);
    };
MarkdownToHtmlPipe.ɵfac = function MarkdownToHtmlPipe_Factory(t) { return new (t || MarkdownToHtmlPipe)(); };
MarkdownToHtmlPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "MarkdownToHtml", type: MarkdownToHtmlPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MarkdownToHtmlPipe, [{
        type: core_1.Pipe,
        args: [{
                name: 'MarkdownToHtml'
            }]
    }], function () { return []; }, null); })();
    return MarkdownToHtmlPipe;
}());
/** @nocollapse */
MarkdownToHtmlPipe.ctorParameters = function () { return []; };
exports.MarkdownToHtmlPipe = MarkdownToHtmlPipe;

